import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class Accordion extends Component {
  static propTypes = {
    multiple: PropTypes.bool,
    children: PropTypes.any.isRequired
  }
  static defaultProps = {
    multiple: false
  }

  constructor(props) {
    super(props)
    this.state = {
      items: []
    }
  }

  componentWillMount() {
    const { children } = this.props
    const content = [].concat(children)

    const items = content.map((child, index) => ({
      id: index,
      active: child.props.default
    }))

    this.setState({
      items: this.state.items.concat(items)
    })
  }

  handleToggle = index => {
    const { multiple } = this.props
    const { items } = this.state
    let newItems = Object.assign([], items)

    if (!multiple) {
      newItems = newItems.map(item => ({
        ...item,
        active: false
      }))
    }

    newItems[index] = {
      id: index,
      active: !items[index].active
    }

    this.setState({
      items: newItems
    })
  }

  render() {
    const { children } = this.props
    const content = [].concat(children)

    return (
      <div>
        {content.map((child, index) => {
          return React.cloneElement(child, {
            key: index,
            item: this.state.items[index],
            handleToggle: this.handleToggle
          })
        })}
      </div>
    )
  }
}
